import {Alert, Checkbox, circularProgressClasses, styled} from "@mui/material";
import * as React from "react";
import GlobalStyles from "@mui/material/GlobalStyles/GlobalStyles";
import TopBar from "../../../components/TopBarV2";
import StepperProjectSetup from "../../../components/stepper-ps";
import Container from "@mui/material/Container/Container";
import firebase from "../../../firebase/firebase";
import InputAdornment from '@mui/material/InputAdornment';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { useFormik, FieldArray, getIn, FormikProvider } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { AuthUserContext } from "../../../providers/AuthProvider";
import Stack from "@mui/material/Stack/Stack";
import Typography from "@mui/material/Typography/Typography";
import Box from "@mui/material/Box/Box";
import TextField from "@mui/material/TextField/TextField";
import MenuItem from "@mui/material/MenuItem/MenuItem";
import Button from "@mui/material/Button/Button";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import HelpOutlineIcon from "@mui/material/SvgIcon/SvgIcon";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import { CheckCircle } from "@mui/icons-material";
import Fab from "@mui/material/Fab/Fab";
import ProjectSetup from "../../../validation/project-setup";
import Grid from "@mui/material/Grid/Grid";
import PostNotification from "../../../helpers/post-notification";
import ScrollToTop from "../../../utils/scrollTop";
import PostActivity from "../../../helpers/post-activity";

function createData(
	name: string,
	calories: number,
	fat: number,
	carbs: number,
	protein: number
) {
	return { name, calories, fat, carbs, protein };
}

const rows = [
	createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
	createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
	createData("Eclair", 262, 16.0, 24, 6.0),
	createData("Cupcake", 305, 3.7, 67, 4.3),
	createData("Gingerbread", 356, 16.0, 49, 3.9),
];

function StepFourContract() {
	const storageRef = firebase.storage().ref();
	const { user, profile } = React.useContext(AuthUserContext);
	const navigator = useNavigate();
	let { projectId } = useParams();

	const Input = styled("input")({
		display: "none",
	});
	const Quit = () => {
		navigator(`/creator/projects/list`);
	}
	const handleKeyPress = (event) => {
		if(event.key === "."){
			event.preventDefault()
		}
	}

	const [files, setFiles] = React.useState([]);
	const [isLoading, setLoading] = React.useState();
	const [contractError, setContractError] = React.useState(false);
	const setFile = (e) => {
		const list = files ? [...files] : [];

		list.push({ file: e.target.files[0], progress: 0 });
		setFiles(list);
	};
	const uploadFile = () => {
		files.forEach((file, i) => {
			if (file.progress === 0) {
				const path = `projects/contracts/${user?.uid}/${file.file.name}`;
				const uploadTask = storageRef.child(path).put(file.file);
				uploadTask.on(
					"state_changed",
					(snapshot) => {
						// Observe state change events such as progress, pause, and resume
						// Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
						const progress =
							(snapshot.bytesTransferred / snapshot.totalBytes) *
							100;
						const newState = files;
						newState[i].progress = progress;
						setFiles([...newState]);
						console.log("Upload is " + progress + "% done");
						switch (snapshot.state) {
							case firebase.storage.TaskState.PAUSED: // or 'paused'
								console.log("Upload is paused");
								break;
							case firebase.storage.TaskState.RUNNING: // or 'running'
								console.log("Upload is running");
								break;
						}
					},
					(error) => {},
					() => {
						const newState = files;
						newState[i].progress = 100;
						newState[i].url = path;
						setFiles([...newState]);
						setContractError(false)
						// Handle successful uploads on complete
						// For instance, get the download URL: https://firebasestorage.googleapis.com/...
					}
				);
			} else {
				return file;
			}
		});
	};
	const formik = useFormik({
		initialValues: ProjectSetup.StepFourContractInitialValues,
		validationSchema: ProjectSetup.StepFourContractSchema,
		onSubmit: async (values) => {
			setLoading(true);

			/*
			 * TODO  document update  {projects} collection
			 * */
			try {
				console.log(`Step foue form data post`);
				const projectRef = firebase
					.firestore()
					.collection("projects")
					.doc(projectId);
				const project = await projectRef.get()

				if (files && files.length  > 0 && files[0].url) {
					const objUpdate = {
						status: "pending",
						workingStatus: "pending",
						draft: false,
						contract: {
							...values,
							contactPath: files[0].url,
						},
						updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
					};
					const postId = await PostNotification({
						title: "A new project was posted",
						text: "A new project was posted. Click here to review and allow publication.",
						uid: null,
						createdBy: "self",
						showing: ["super", "admin"],
						link: "/admin/project-pending",
					});
					await PostNotification({
						title: "Pending Approval",
						text: "Taost will notify you once we have a project update",
						uid: profile?.uid,
						createdBy: "self",
						link: "/creator/project-details/" + projectId,
					});
					PostActivity({
						text: `You posted a new project titled “${project?.data()?.title || ''}"`,
						uid: profile.uid,
						createdBy:profile?.uid
					}).then()
					console.log(`Notify Admin ${postId}`);
					await projectRef.update(objUpdate);
					navigator(`/creator/dashboard`);
					setLoading(false);
				} else {
					setContractError(true)
					setLoading(false);
					// alert('Please upload contract....')
				}
			} catch (e) {
				setLoading(false);
			}
		},
	});

	return (
		<React.Fragment>
			<ScrollToTop/>
			<GlobalStyles
				styles={{ ul: { margin: 0, padding: 0, listStyle: "none" } }}
			/>
			{/* Hero unit */}
			{/*<TopBar showBar={true}/>*/}
			<StepperProjectSetup stepNumber={4} />
			<FormikProvider value={formik}>
				<Box component="form" onSubmit={formik.handleSubmit}>
					<Container maxWidth="md" sx={{ py: 5 }}>
						<Stack
							direction={"column"}
							justifyContent="flex-start"
							spacing={5}
							sx={{ width: "100%" }}>

							<TextField
								label={
									"Are you investing an initial amount as a Creator? *"
								}
								name={"creatorInitialAmount"}
								select
								sx={{ textAlign: "left" }}
								value={formik.values.creatorInitialAmount}
								onChange={formik.handleChange}
								error={
									formik.touched.creatorInitialAmount &&
									Boolean(formik.errors.creatorInitialAmount)
								}
								helperText={
									formik.touched.creatorInitialAmount &&
									formik.errors.creatorInitialAmount
								}>
								<MenuItem value={"Yes"}>Yes</MenuItem>
								<MenuItem
									value={"No"}
									onClick={() =>
										(formik.values.howMuchInvesting = 0)
									}>
									No
								</MenuItem>
							</TextField>
							{formik.values.creatorInitialAmount === "Yes" ? (
								<TextField
									label={"How much are you investing?"}
									name={"howMuchInvesting"}
									placeholder={"100.000"}
									value={formik.values.howMuchInvesting}
									onChange={formik.handleChange}
									InputProps={{
										endAdornment: (
											<InputAdornment position="end">
												<AttachMoneyIcon/>
											</InputAdornment>
										)
										
           
										
									}}
							
								/>
							) : (
								<></>
							)}

							<TextField
								label={
									"How many investors do you require for this project?"
								}
								name={"howMuchInvestors"}
								placeholder={"1"}
								value={formik.values.howMuchInvestors}
								onChange={formik.handleChange}
								error={
									formik.touched.howMuchInvestors &&
									Boolean(formik.errors.howMuchInvestors)
								}
								helperText={
									formik.touched.howMuchInvestors &&
									formik.errors.howMuchInvestors
								}
							/>
							<TextField
								label={"Minimum investment per investor"}
								name={"minimumInvestment"}
								InputProps={{
										endAdornment: (
											<InputAdornment position="end">
												<AttachMoneyIcon/>
											</InputAdornment>
										)
										
           
										
									}}
								type="number"
								onKeyDown={handleKeyPress}
								placeholder={"100000"}
								value={formik.values.minimumInvestment}
								onChange={formik.handleChange}
								error={
									formik.touched.minimumInvestment &&
									Boolean(formik.errors.minimumInvestment)
								}
								helperText={
									(formik.touched.minimumInvestment &&
									formik.errors.minimumInvestment)? "Investment should be a number" : ""
								}
								
							/>
							<TextField
								label={"Maximum investment per investor"}
								name={"maximumInvestment"}
								placeholder={"200000"}
								type="number"
								onKeyDown={handleKeyPress}
								value={formik.values.maximumInvestment}
								onChange={formik.handleChange}
								error={
									formik.touched.maximumInvestment &&
									Boolean(formik.errors.maximumInvestment)
								}
								helperText={
									(formik.touched.maximumInvestment &&
									formik.errors.maximumInvestment )? "Investment should be a number" : ""
								}
								InputProps={{
										endAdornment: (
											<InputAdornment position="end">
												<AttachMoneyIcon/>
											</InputAdornment>
										)
										
           
										
									}}
							/>
							<Typography align="left" sx={{fontSize: "16px"}}>According to the requirements of <b>Regulation Crowdfunding</b>, Creators in this platform are permitted to raise a maximum aggregate amount of $1,070,000 in a 12-month period per project.</Typography>
							<Typography align="left" sx={{fontSize: "16px"}}>For more information you can access the Regulation Crowfunding by clicking here.</Typography>
							<Grid   container
									direction="row"
									justifyContent="flex-start"
									alignItems="center">
							<Checkbox
							inputprops={{ 'aria-label': 'controlled' }}
							name='termAgreement'
							checked={formik.values.termAgreement} onChange={formik.handleChange}/>
							<Typography align="left" sx={{fontSize: "16px"}}>I can confirm that I have read and agree with the terms above</Typography>
							{formik.touched.termAgreement && formik.errors.termAgreement}
							</Grid>
							<TableContainer>
								<Typography
									variant={"h4"}
									sx={{
										color: "#363636",
										textAlign: "left",
									}}>
									Project milestones
								</Typography>
								<Table
									
									aria-label="simple table">
									<TableHead>
										<TableRow
											sx={{ "td, th": { border: 0 } }}>
											<TableCell
												align="center"
												component="th"
												scope="row">
												<Typography
													variant={"h6"}
													color={"primary"}>
													Description
												</Typography>{" "}
											</TableCell>
											<TableCell align="center">
												<Typography
													variant={"h6"}
													color={"primary"}>
													Amount
												</Typography>
											</TableCell>
											<TableCell align="center">
												<Typography
													variant={"h6"}
													color={"primary"}>
													DeadLine
												</Typography>
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										<FieldArray
											name={"millstones"}
											render={(arrayHelpers) => {
												return (
													<>
														{arrayHelpers?.form.values.millstones.map(
															(row, i) => (
																<>
																	<TableRow
																		key={
																			row.name
																		}
																		sx={{
																			"td, th":
																				{
																					border: 0,
																				},
																		}}>
																		<TableCell
																			component="th"
																			scope="row">
																			<TextField
																				placeholder={
																					"Description"
																				}
																				variant={
																					"outlined"
																				}
																				name={`millstones.${i}.description`}
																				value={
																					formik
																						.values
																						.millstones[
																						i
																					]
																						.description
																				}
																				onChange={
																					formik.handleChange
																				}
																				error={
																					formik.touched &&
																					formik
																						.touched
																						.millstones !==
																						undefined &&
																					formik
																						.errors
																						.millstones !==
																						undefined &&
																					formik
																						.touched
																						.millstones[
																						i
																					]
																						.description &&
																					Boolean(
																						formik
																							.errors
																							.millstones[
																							i
																						]
																							.description
																					)
																				}
																				helperText={
																					formik.touched &&
																					formik
																						.touched
																						.millstones !==
																						undefined &&
																					formik
																						.errors
																						.millstones !==
																						undefined &&
																					formik
																						.touched
																						.millstones[
																						i
																					]
																						.description &&
																					formik
																						.errors
																						.millstones[
																						i
																					]
																						.description
																				}
																				sx={{
																					backgroundColor:
																						"#E3E8F0",
																					borderColor:
																						"#E3E8F0",
																						width:"250px"
																				}}
																				
																				
																			/>
																		</TableCell>
																		<TableCell align="center">
																			<TextField
																			InputProps={{
										endAdornment: (
											<InputAdornment position="end">
												<AttachMoneyIcon/>
											</InputAdornment>
										)
										
           
										
									}}
																				placeholder={
																					"1000"
																				}
																				type="number"
																				onKeyDown={handleKeyPress}
																				name={`millstones.${i}.amount`}
																				value={
																					formik
																						.values
																						.millstones[
																						i
																					]
																						.amount
																				}
																				onChange={
																					formik.handleChange
																				}
																				error={
																					formik.touched &&
																					formik
																						.touched
																						.millstones !==
																						undefined &&
																					formik
																						.errors
																						.millstones !==
																						undefined &&
																					formik
																						.touched
																						.millstones[
																						i
																					]
																						.amount &&
																					Boolean(
																						formik
																							.errors
																							.millstones[
																							i
																						]
																							.amount
																					)
																				}
																				helperText={
																					(formik.touched &&
																					formik
																						.touched
																						.millstones !==
																						undefined &&
																					formik
																						.errors
																						.millstones !==
																						undefined &&
																					formik
																						.touched
																						.millstones[
																						i
																					]
																						.amount &&
																					formik
																						.errors
																						.millstones[
																						i
																					]
																						.amount)? "Amount should be a number" : ""
																				}
																				
																				sx={{
																					width:"250px"
																				}}
																			/>
																		</TableCell>
																		<TableCell align="center">
																			<TextField
																				type="date"
																				inputProps={{ min: "2022-11-01"}}
																				placeholder={
																					"Jan 12, 22"
																				}
																				name={`millstones.${i}.deadLine`}
																				value={
																					formik
																						.values
																						.millstones[
																						i
																					]
																						.deadLine
																				}
																				onChange={
																					formik.handleChange
																				}
																				error={
																					formik.touched &&
																					formik
																						.touched
																						.millstones !==
																						undefined &&
																					formik
																						.errors
																						.millstones !==
																						undefined &&
																					formik
																						.touched
																						.millstones[
																						i
																					]
																						.deadLine &&
																					Boolean(
																						formik
																							.errors
																							.millstones[
																							i
																						]
																							.deadLine
																					)
																				}
																				helperText={
																					formik.touched &&
																					formik
																						.touched
																						.millstones !==
																						undefined &&
																					formik
																						.errors
																						.millstones !==
																						undefined &&
																					formik
																						.touched
																						.millstones[
																						i
																					]
																						.deadLine &&
																					formik
																						.errors
																						.millstones[
																						i
																					]
																						.deadLine
																				}
																				sx={{
																					width:"250px"
																				}}
																			/>
																		</TableCell>
																	</TableRow>
																</>
															)
														)}
														<Button
															onClick={() => {
																arrayHelpers.push(
																	{
																		id: Math.random(),
																		description:
																			"",
																		amount: "",
																		deadLine:
																			"",
																	}
																);
															}}
															variant={"outlined"}
															sx={{
																borderRadius: 0,
																mt: 3,
																ml: 2,
															}}
															startIcon={
																<AddIcon />
															}>
															Add another
														</Button>
													</>
												);
											}}
										/>
									</TableBody>
								</Table>

								<Typography
									variant={"body2"}
									color={"secondary"}
									sx={{ mt: 3, ml: 2, pr: 4 }}>
									<b>*Threshold information:</b> In case of the
									project not being fully funded, you will
									only be able to move foward if you raise the
									amount of the first milestone.
								</Typography>
							</TableContainer>
						</Stack>
					</Container>

					<Container
						maxWidth="100%"
						sx={{ py: 8, backgroundColor: "#E3E8F0" }}>
						<Container maxWidth="sm">
							<Stack
								direction="row"
								justifyContent="flex-start"
								alignItems="center"
								spacing={5}>
								<label
									htmlFor="avidance-contract"
									style={{ width: "100%" }}>
									<Button
										variant={"outlined"}
										sx={{ py: 1.3, borderRadius: 0 }}
										fullWidth
										component={"span"}
										startIcon={<UploadFileIcon />}>
										Upload Contract
									</Button>

									<Input
										accept="**/*"
										id="avidance-contract"
										multiple
										type="file"
										onChange={setFile}
									/>
								</label>

								<Button
									variant={"contained"}
									sx={{ py: 1.3, px: 5, borderRadius: 0 }}
									onClick={uploadFile}>
									Upload
								</Button>
							</Stack>

							<Stack
								direction={"column"}
								spacing={3}
								sx={{ my: 2 }}>
								{files &&
									files.length > 0 &&
									files.reverse().map((d, i) => (
										<Stack
											key={i}
											direction="row"
											justifyContent="flex-start"
											alignItems="center"
											spacing={2}
											sx={{
												borderBottom:
													"1px solid #204488",
												paddingY: 2,
											}}>
											<Stack
												direction="row"
												justifyContent="flex-start"
												alignItems="center"
												spacing={2}
												sx={{ flex: 1 }}>
												{d.progress > 0 &&
												d.progress < 100 ? (
													<CircularProgress
														variant="indeterminate"
														disableShrink
														sx={{
															color: (theme) =>
																theme.palette
																	.mode ===
																"light"
																	? "#b9b9bc"
																	: "#909093",
															animationDuration:
																"550ms",
															left: 0,
															[`& .${circularProgressClasses.circle}`]:
																{
																	strokeLinecap:
																		"round",
																},
														}}
														size={30}
														thickness={4}
													/>
												) : <>
												{d.progress === 100 && <CheckCircle color={"primary"} style={{ height: 20, width: 20}}/>}
												{(!d.progress) && 
																<img
																src="/assets/icons/file-upload.png"
																style={{ height: 20, width: 20 }}
																alt=""
																/>
															  }
												</>}

												<Typography color={"primary"}>
													{d.file.name}
												</Typography>
											</Stack>
											<Box
												sx={{
													paddingX: 2,
													borderRight:
														"1px solid #ccc",
												}}>
												<Box
													sx={{
														p: 1,
														background: "#204488",
														fontSize: "small",
														color: "#fff",
													}}>
													{(
														d.file.size /
														1024 /
														1024
													).toFixed(0) == 0
														? (
																d.file.size /
																1024
														  ).toFixed(0) + " KB"
														: (
																d.file.size /
																1024 /
																1024
														  ).toFixed(0) + " MB"}
												</Box>
											</Box>
											<Fab
												color={"primary"}
												sx={{ boxShadow: "none" }}
												size={"small"}
												aria-label="delete"
												onClick={() => {
													setFiles([
														...files.slice(0, i),
														...files.slice(
															i + 1,
															files.length
														),
													]);
												}}>
												<ClearIcon />
											</Fab>
										</Stack>
									))}
							</Stack>

						</Container>
					</Container>

					<Container maxWidth="md" sx={{ py: 5 }}>
						<Stack
							direction={"column"}
							justifyContent="flex-start"
							spacing={5}
							sx={{ width: "100%" }}>
							<Typography
								variant={"h4"}
								sx={{ color: "#363636", textAlign: "left" }}>
								PLEASE ADD YOUR BANK DETAILS
							</Typography>
							<TextField
								label={"Country"}
								name={"bankDetails.country"}
                value={formik.values.bankDetails.country}
                onChange={formik.handleChange}
                error={Boolean(
                  getIn(formik.touched, 'bankDetails.country') &&
                  getIn(formik.errors, 'bankDetails.country')
                )}
                helperText={
                  getIn(formik.touched, 'bankDetails.country') &&
                  getIn(formik.errors, 'bankDetails.country')
                }
              />
              <TextField
                label={"Bank name"}
								name={"bankDetails.bankName"}
                value={formik.values.bankDetails.bankName}
                onChange={formik.handleChange}
                error={Boolean(
                  getIn(formik.touched, 'bankDetails.bankName') &&
                  getIn(formik.errors, 'bankDetails.bankName')
                )}
                helperText={
                  getIn(formik.touched, 'bankDetails.bankName') &&
                  getIn(formik.errors, 'bankDetails.bankName')
                }
							/>
							<TextField
								label={"Account title"}
								name={"bankDetails.accountTitle"}
                value={formik.values.bankDetails.accountTitle}
                onChange={formik.handleChange}
                error={Boolean(
                  getIn(formik.touched, 'bankDetails.accountTitle') &&
                  getIn(formik.errors, 'bankDetails.accountTitle')
                )}
                helperText={
                  getIn(formik.touched, 'bankDetails.accountTitle') &&
                  getIn(formik.errors, 'bankDetails.accountTitle')
                }
              />
              <TextField
                label={"Recipient’s full name"}
								name={"bankDetails.recipientName"}
                value={formik.values.bankDetails.recipientName}
                onChange={formik.handleChange}
                error={Boolean(
                  getIn(formik.touched, 'bankDetails.recipientName') &&
                  getIn(formik.errors, 'bankDetails.recipientName')
                )}
                helperText={
                  getIn(formik.touched, 'bankDetails.recipientName') &&
                  getIn(formik.errors, 'bankDetails.recipientName')
                }
              />
              <TextField
                label={"Recipient’s address"}
								name={"bankDetails.recipientAddress"}
                value={formik.values.bankDetails.recipientAddress}
                onChange={formik.handleChange}
                error={Boolean(
                  getIn(formik.touched, 'bankDetails.recipientAddress') &&
                  getIn(formik.errors, 'bankDetails.recipientAddress')
                )}
                helperText={
                  getIn(formik.touched, 'bankDetails.recipientAddress') &&
                  getIn(formik.errors, 'bankDetails.recipientAddress')
                }
              />
              <TextField
                label={"Account number"}
								name={"bankDetails.accountNumber"}
                value={formik.values.bankDetails.accountNumber}
                onChange={formik.handleChange}
                error={Boolean(
                  getIn(formik.touched, 'bankDetails.accountNumber') &&
                  getIn(formik.errors, 'bankDetails.accountNumber')
                )}
                helperText={
                  getIn(formik.touched, 'bankDetails.accountNumber') &&
                  getIn(formik.errors, 'bankDetails.accountNumber')
                }
							/>
							<TextField
								label={"BIC/SWIFT code"}
								name={"bankDetails.swiftCode"}
                value={formik.values.bankDetails.swiftCode}
                onChange={formik.handleChange}
                error={Boolean(
                  getIn(formik.touched, 'bankDetails.swiftCode') &&
                  getIn(formik.errors, 'bankDetails.swiftCode')
                )}
                helperText={
                  getIn(formik.touched, 'bankDetails.swiftCode') &&
                  getIn(formik.errors, 'bankDetails.swiftCode')
                }
							/>
						</Stack>
						{contractError &&
							<Alert severity={'error'} sx={{mt:5}}>
								<Typography variant={'body2'} color={'error'} sx={{textAlign: 'left'}} >
									Please upload a contract.
								</Typography>
							</Alert>}
					</Container>

					<Stack
						spacing={2}
						direction="row"
						sx={{
							my: 5,
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}>
						<Button
							sx={{
								pt: 1.2,
								pb: 1.2,
								pl: 5,
								pr: 5,
								textDecoration: "underline",
							}}
							onClick ={Quit}>
							Quit without saving
						</Button>

						<Button
							variant="contained"
							sx={{ pt: 1.2, pb: 1.2, pl: 5, pr: 5 }}
							type="submit"
							disabled={isLoading}>
							Next
						</Button>
					</Stack>
				</Box>
			</FormikProvider>
		</React.Fragment>
	);
}
export default StepFourContract;
